var render = function render(){var _vm=this,_c=_vm._self._c;return _c('topic-form',{attrs:{"value":_vm.value},on:{"topic:update":(t) => { _vm.$emit('topic:update', t) }}})
}
var staticRenderFns = []

export { render, staticRenderFns }